export default `
# Kontakt

## Hlavní organizátor

Petr Hodač, <p.hodac@sh.cvut.cz>, +420 724 782 534

## Webmaster

Michal Kothera, <m.kothera@sh.cvut.cz>, +420 725 731 221

## Audio - Video

AVC.SH, <avc@siliconhill.cz>, avc.siliconhill.cz

## Organizace

Klub Sillicon Hill: <info@siliconhill.cz>  
Studentská unie ČVUT: <su@su.cvut.cz>  
Fakulta informačních technologií: http://fit.cvut.cz/  

**Kontaktní adresa:**  
Studentská unie ČVUT, klub Silicon Hill  
Vaníčkova 7  
169 00 Praha 6
`



// WEBPACK FOOTER //
// ./src/content/installfest/venue/text2.js